import React from "react";

function Footer() {
  return (
    <footer
      style={{
        textAlign: "center",
        fontSize: "0.9rem",
        color: "#666",
        padding: "2rem 1rem",
        borderTop: "1px solid #ddd",
        marginTop: "2rem",
        backgroundColor: "#3b3b3b",
      }}
    >
      <p>© {new Date().getFullYear()} Pixel Creator. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
